import {
  AiEyebrow,
  Badge,
  Card,
  C,
  CONTRACT,
  CONF,
  KVRow,
  OPPS,
  PROFILE,
  READINESS,
  REC_AREAS,
  RISKS,
  SectionTitle,
} from "./shared";

export function Overview() {
  return (
    <div className="npov-root">
      <div className="npov-summary">
        <div className="npov-summary-head">
          <span className="npov-ai-chip">AI</span>
          <span className="npov-summary-label">AI Negotiation Summary</span>
        </div>
        <p className="npov-summary-text">
          Supplier pricing is 9.4% above market benchmark — $76,250 a year on this family alone. Focus the hour on logistics and packaging, which together hold $450k and have never been challenged, and anchor on the tooling amortisation error. Margin is inside the sector band — concede it early and visibly. Recommended target saving is $1.2M across the category, with a landing price of $30.67/pc and a walk-away at $31.70/pc. Serve renewal notice by 2 Oct to keep the alternate credible.
        </p>
      </div>
      <div className="npov-grid np-2col">
        <Card>
          <SectionTitle>Supplier profile</SectionTitle>
          <div className="npov-card-content">
            {PROFILE.map((row, index) => {
              const profileStyle = row[3] || { bg: C.tealBg, fg: C.greenInk };
              return (
                <KVRow key={index} k={row[0]} last={index === PROFILE.length - 1}>
                  {row[2] === "chip" ? <Badge bg={profileStyle.bg} fg={profileStyle.fg}>{row[1]}</Badge>
                    : <span className={`npov-value${row[2] === "sb" ? " npov-value--semibold" : ""}`}>{row[1]}</span>}
                </KVRow>
              );
            })}
          </div>
        </Card>
        <Card>
          <SectionTitle>Contract &amp; spend</SectionTitle>
          <div className="npov-card-content">
            {CONTRACT.map((row, index) => (
              <KVRow key={index} k={row[0]} last={index === CONTRACT.length - 1}>
                <span className={`npov-value${row[2].includes("sb") ? " npov-value--semibold" : ""}`}>{row[1]}</span>
                {row[2] === "sb-chip" && <Badge bg={C.chipBg} fg={C.slate}>{row[3]}</Badge>}
              </KVRow>
            ))}
          </div>
        </Card>
      </div>
      <Card>
        <div className="npov-readiness-layout">
          <div className="npov-readiness-score-block">
            <div className="npov-readiness-ring">
              <div className="npov-readiness-ring-arc" />
              <div className="npov-readiness-ring-core">
                <span className="npov-readiness-score">82</span>
              </div>
            </div>
            <div className="npov-readiness-label">AI negotiation readiness</div>
          </div>
          <div className="npov-readiness-grid">
            {READINESS.map((item) => (
              <div key={item.label} className="npov-readiness-item">
                <div className="npov-readiness-item-head"><span className="npov-readiness-item-label">{item.label}</span><span className="npov-readiness-item-value">{item.v}</span></div>
                <progress className="npov-readiness-progress" value={item.v} max={100} />
              </div>
            ))}
          </div>
        </div>
      </Card>
      <div className="npov-grid np-2col">
        <Card>
          <div className="npov-headline-row"><SectionTitle size={18}>Top opportunities</SectionTitle><AiEyebrow label="AI identified" color={C.purple3} /></div>
          <div className="npov-list npov-list--spacious">
            {OPPS.map((item, index) => (
              <div key={index}>
                <div className="npov-item-head"><span className="npov-item-title">{item[0]}</span><Badge bg={CONF[item[2]].bg} fg={CONF[item[2]].fg}>{item[1]}</Badge></div>
                <div className="npov-item-body npov-item-body--alt">{item[3]}</div>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <SectionTitle size={18}>Key risks</SectionTitle>
          <div className="npov-list npov-list--spacious npov-list--mt">
            {RISKS.map((item, index) => {
              const severity = item[2] === "high" ? { bg: "#FEE2E2", fg: C.redInk } : item[2] === "med" ? { bg: C.amberBg, fg: C.amberInk } : { bg: C.tealBg, fg: C.greenInk };
              return <div key={index}><div className="npov-item-head npov-item-head--spread"><span className="npov-item-title">{item[0]}</span><Badge bg={severity.bg} fg={severity.fg}>{item[1]}</Badge></div><div className="npov-item-body">{item[3]}</div></div>;
            })}
          </div>
        </Card>
      </div>
      <Card>
        <SectionTitle>Recommended negotiation areas</SectionTitle>
        <div className="npov-table-wrap">
          <div className="npov-table-head"><span className="npov-table-h">Area</span><span className="npov-table-h">Approach / Strategy</span><span className="npov-table-h npov-table-h--right">Savings Opportunity</span></div>
          {REC_AREAS.map((row, index) => <div key={index} className={`npov-table-row${index === REC_AREAS.length - 1 ? " is-last" : ""}`}><span className="npov-table-area">{row[0]}</span><span className="npov-table-approach">{row[1]}</span><span className="npov-table-saving">{row[2]}</span></div>)}
        </div>
      </Card>
    </div>
  );
}
